import React, { useState, useEffect } from "react";
//outsource
import { Row, Col, Modal, Button, Empty, Space, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { allRedeemNotesSelector } from "../../../store/credit_redeem/credit_redeem.selector";
import { addCreditNotesRedeem } from "../../../store/credit_redeem/credit_redeem.action";
import { labelDateSelector } from "../../../store/var/var.selector";
import { detailBranchSelector } from "../../../store/branch/branch.selector";
import { PlusOutlined } from "@ant-design/icons";
import CardNote from "../component/component/card_note";
import CardRedeemNote from "../component/component/card_redeem_note";
//components

const DialogCreditRedeemAdd = ({ open, setOpen }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------
  const [data, setData] = useState([]);
  const [edit, setEdit] = useState(true);

  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const label = useSelector(labelDateSelector);
  const branch = useSelector(detailBranchSelector);
  const creditNotes = useSelector(allRedeemNotesSelector);
  // -------------------------- FUNCTION -----------------------
  const closeDialog = () => {
    setOpen(false);
    // setEdit(false);
  };

  const handleAddNote = () => {
    const dataIndex = data?.length || 0;
    let result = [...data, { note: "", dataIndex, value: 0 }];
    setData(result);
  };

  const handleRemoveNote = (index) => {
    const newData = data?.filter((item) => item?.dataIndex !== index);
    setData(newData);
  };

  const handleChange = (index, key, value) => {
    const newData = data?.map((item) => {
      const dataIndex = item?.dataIndex;
      if (dataIndex === index) {
        return {
          ...item,
          [key]: value,
        };
      } else {
        return item;
      }
    });
    setData(newData);
  };

  const handleSave = () => {
    if (data && label && branch) {
      let result = {
        branch: branch?.id || "",
        owner: branch?.owner || "",
        date: label,
        notes: data,
      };

      dispatch(
        addCreditNotesRedeem({ data: result }, (res) => {
          if (res.status === 200) {
            message.success("Note Added Successfully!");
            setOpen(false);
          } else {
            message.error(res?.data);
          }
        })
      );
    }
  };

  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    if (creditNotes) {
      let notes = creditNotes?.notes;
      setData(notes);
    } else {
      setData([]);
    }
  }, [dispatch, creditNotes]);
  // -------------------------- RENDER --------------------------
  const renderBody = () => {
    return (
      <Row style={{ width: "100%" }}>
        <Col span={24}>{renderListCredits()}</Col>
        <Col style={{ marginTop: 20 }} span={24}>
          <Button
            disabled={!edit}
            type="dashed"
            onClick={handleAddNote}
            icon={<PlusOutlined />}
          >
            Add Note
          </Button>
        </Col>
      </Row>
    );
  };

  const renderListCredits = () => {
    if (data?.length > 0) {
      return (
        <Row style={{ width: "100%" }}>
          {data?.map((item) => {
            return (
              <CardRedeemNote
                edit={edit}
                data={item}
                handleChange={handleChange}
                handleRemoveNote={handleRemoveNote}
              />
            );
          })}
        </Row>
      );
    }

    return <Empty />;
  };

  const renderFooter = () => {
    return (
      <Row>
        <Col span={24}>
          <Space>
            {renderCancelBtn()}
            {renderSaveBtn()}
          </Space>
        </Col>
      </Row>
    );
  };

  const renderCancelBtn = () => {
    return <Button onClick={closeDialog}>Cancel</Button>;
  };

  const renderSaveBtn = () => {
    if (!edit) {
      return (
        <Button onClick={() => setEdit(true)} type="primary">
          Edit
        </Button>
      );
    }

    return (
      <Button onClick={handleSave} className="done-btn" type="primary">
        Save
      </Button>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <Modal
      title="Add Gift Taken"
      open={open}
      onCancel={closeDialog}
      footer={renderFooter()}
    >
      {renderBody()}
    </Modal>
  );
};

export default DialogCreditRedeemAdd;
